"use client";

import type { ReactElement } from "react";
import "./engineering2-skip.css";
import { useTranslations } from "next-intl";

const CHORES: readonly string[] = [
  "Watch how full the disks are getting",
  "Stay up at night to update the database",
  "Write connection pools and worry about traffic spikes",
  "Decide up front how much RAM and how many CPU cores you need",
];

/**
 * Struck-through ops list with its own heading. Slots into the shipping box.
 */
export function Engineering2SkipBlock(): ReactElement {
  const t = useTranslations("public.engineering2SkipSection");
  return (
    <div className="e2-skip">
      <h3 className="e2-skip-title">
        {t.rich("skipTitle", {
          em: (chunks) => <span className="e2-accent">{chunks}</span>,
        })}
      </h3>
      <ul className="e2-skip-list">
        {CHORES.map((chore: string) => (
          <li className="e2-skip-line" key={chore}>
            <span className="e2-skip-box" aria-hidden={true} />
            <span className="e2-skip-text">{chore}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
